import { enhancedApi } from '@store/generated/pulse';

export const pulseApi = enhancedApi;
export const {
  usePostV2ProviderPulseHeartbeatMutation: usePulseHeartbeat,
  usePostV2ProviderPulseByPulseIdOutcomeMutation: useRecordPulseOutcome,
} = pulseApi;
